import Vue from 'vue';
import productsAPI from "@/api/products";

const getDefaultState = () => ({
  availableHardware: [],
  availableHardwareLoading: false,
  availableHardwareError: false,
  productHardware: [],
  productHardwareRef: [],
  productHardwareLoading: false,
  productHardwareError: false,
  updateProductHardwareLoading: false,
  updateProductHardwareError: false,
});

const state = getDefaultState();

const mutations = {
  AVAILABLE_HARDWARE_BEGIN(state) {
    state.availableHardwareLoading = true;
    state.availableHardwareError = false;
  },
  AVAILABLE_HARDWARE_SUCCESS(state, payload) {
    state.availableHardware = payload;
    state.availableHardwareLoading = false;
  },
  AVAILABLE_HARDWARE_ERROR(state) {
    state.availableHardwareError = true;
    state.availableHardwareLoading = false;
  },

  PRODUCT_HARDWARE_BEGIN(state) {
    state.productHardwareLoading = true;
    state.productHardwareError = false;
  },
  PRODUCT_HARDWARE_SUCCESS(state, payload) {
    state.productHardware = payload;
    state.productHardwareRef = [...payload];
    state.productHardwareLoading = false;
  },
  PRODUCT_HARDWARE_ERROR(state) {
    state.productHardwareError = true;
    state.productHardwareLoading = false;
  },

  UPDATE_PRODUCT_HARDWARE_BEGIN(state) {
    state.updateProductHardwareLoading = true;
    state.updateProductHardwareError = false;
  },
  UPDATE_PRODUCT_HARDWARE_SUCCESS(state, payload) {
    state.productHardware = payload;
    state.productHardwareRef = [...payload];
    state.updateProductHardwareLoading = false;
  },
  UPDATE_PRODUCT_HARDWARE_ERROR(state) {
    state.updateProductHardwareError = true;
    state.updateProductHardwareLoading = false;
  },
  RESET_TO_DEFAULT_REF(state) {
    if(state.productHardwareRef.length) {
      for(var i = 0; i < state.productHardwareRef.length; i++) {
        var newObject = Object.assign({}, state.productHardwareRef[i]);
        Vue.set(state.productHardware, i, newObject);
      }
    } else {
      state.productHardware = [];
    }
  },

  CLEAR_OWN_HARDWARE(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchAvailableHardware({ commit }, {platform}) {
    commit("AVAILABLE_HARDWARE_BEGIN");
    try {
      const response = await productsAPI.loadAvailableHardware({available: 1, platform});
      commit("AVAILABLE_HARDWARE_SUCCESS", response.data);
    } catch(err) {
      commit("AVAILABLE_HARDWARE_ERROR");
      throw err;
    }
  },

  async fetchProductHardware({ commit }, { productId }) {
    commit("PRODUCT_HARDWARE_BEGIN");
    try{
      const response = await productsAPI.loadProductHardware(productId);
      commit("PRODUCT_HARDWARE_SUCCESS", response.data);
    } catch(err) {
      commit("PRODUCT_HARDWARE_ERROR");
      throw err;
    }
  },

  async updateProductHardware({ state, commit, dispatch }, { productId, payload }) {
    commit("UPDATE_PRODUCT_HARDWARE_BEGIN");
    try{
      const response = await productsAPI.updateProductHardware(productId, payload);
      const alert = {
        type: "success",
        message: "Update successful!",
      };
      dispatch("alerts/setAlert", alert, { root: true });
      commit("UPDATE_PRODUCT_HARDWARE_SUCCESS", response.data);
    } catch(err) {
      commit("UPDATE_PRODUCT_HARDWARE_ERROR");
      const alert = {
        type: "error",
        message: `There has been an error: ${ err.response.data.message }`,
      };
      dispatch("alerts/setAlert", alert, { root: true });
      throw err;
    }
  },

  resetDefaultRef({ commit }) {
    commit("RESET_TO_DEFAULT_REF");
  }
};

const getters = {
  getAvailableHardware: (state) => state.availableHardware.filter(e => {
    if(e.availability) {
      return ['easy', 'medium'].includes(e.availability.toLowerCase());
    }
  }),
  getAvailableHardwareLoading: (state) => state.availableHardwareLoading,
  getAvailableHardwareError: (state) => state.availableHardwareError,
  getProductHardware: (state) => state.productHardware.map(userHardware => {
    const available = state.availableHardware.find(e => e.id === userHardware.voip_device_model_id);
    if(available) {return { id: available.id, name: available.name, difficulty: available.availability, mac_address: userHardware.mac_address }};
  }).reduce((acc, obj) => {
    if(!acc.hasOwnProperty(obj.id)) {
      acc[obj.id] = obj;
      acc[obj.id]["quantity"] = 0;
      acc[obj.id]["mac_addresses"] = [];
    }
    acc[obj.id]["quantity"] += 1;
    acc[obj.id]["mac_addresses"].push(obj.mac_address);
    return acc;
  }, {}),
  getProductHardwareLoading: (state) => state.productHardwareLoading,
  getProductHardwareError: (state) => state.productHardwareError,
  getUpdateProductHardwareLoading: (state) => state.updateProductHardwareLoading,
  getUpdateProductHardwareError: (state) => state.updateProductHardwareError
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
